<template>
  <div class="index">
    <div class="zhezhao">
      <div class="imgsss">
        <el-button type="primary" @click="shutDown" icon="el-icon-close" circle></el-button>
      </div>
    </div>
    <!-- 左侧二维码 -->
    <!-- <div class="appcode">
      <img src="../assets/fangyi/yidaimaimg.png" alt />
    </div> -->
    <!-- 右侧礼包 -->
    <!-- <div class="gift_box">
      <img @click="tohqlb" src="../assets/fangyi/hqlblog.png" alt />
      <br />
      <img @click="tofangyi" src="../assets/fangyi/xydzqlog.png" alt />
    </div>-->
    <!-- 头图 -->
    <!-- <div class="slideshow">
      <img
        class="slideshow-image"
        @click="tofangyi"
        src="../assets/imgs/index/headimg3.png"
      />
      <img
        class="slideshow-image"
        @click="tohqlb"
        src="../assets/imgs/index/headimg2.png"
      />

      <img
        class="slideshow-image"
        @click="tofangyi"
        src="../assets/imgs/index/headimg3.png"
      />
    </div>-->
    <div class="swiper-container" ref="mySwiper1">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div class="slideshow">
            <img class="slideshow-image" style="backgroud:#fff" @click="tofangyi" src="../assets/imgs/index/head_bg1.png" />
          </div>
        </div>
        <div class="swiper-slide">
          <div class="slideshow">
            <img class="slideshow-image" src="../assets/imgs/index/head_bg3.png" />
          </div>
        </div>
        <div class="swiper-slide">
          <div class="slideshow">
            <img class="slideshow-image" @click="toszrmb" src="../assets/imgs/index/head_bg2.png" />
          </div>
        </div>
        <div class="swiper-slide">
          <div class="slideshow">
            <a href="http://123.57.145.125:8092/indexPage" target="_blank">
              <img class="slideshow-image" src="../assets/imgs/index/head_bg5.png" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- 企业、银行用户 -->

    <div class="user" v-if="showDone">
      <!-- <div class="lipin" v-if="libaoVisible3">
        <div class="btn">
          <img src="../assets/newyearimg/libao_back.png" alt="" />
        </div>
        <div class="midden">
          <img src="../assets/newyearimg/libao_icon.png" alt="" />
        </div>
        <div class="box" @click="getLibao"></div>
      </div>-->
      <img style="width: 100%" src="../assets/imgs/index/index_user_bg.png" alt />
      <div class="tabs">
        <ul class="tab-tilte">
          <!-- 企业 -->
          <li
            @click="cur = 0"
            :class="
              this.cur == 0 && this.getsourceType == 1
                ? 'selectedActive'
                : 'active1'
            "
            :style="
              this.cur == 0
                ? 'background: linear-gradient(189deg, #589dff, #81c3ff, #67b9ff);'
                : ''
            "
            v-show="this.getsourceType == 1 || !this.getsourceType"
          >
            <img class="icon" src="../assets/imgs/index/bussiness_icon.png" />企业用户
          </li>
          <!-- 银行 -->
          <li
            @click="cur = 1"
            :class="
              this.cur == 1 && this.getsourceType == 2
                ? 'selectedActive'
                : 'active1'
            "
            :style="
              this.cur == 1
                ? 'background: linear-gradient(189deg, #589dff, #81c3ff, #67b9ff);'
                : ''
            "
            v-show="this.getsourceType == 2 || !this.getsourceType"
          >
            <img class="icon" src="../assets/imgs/index/bank_icon.png" />银行用户
          </li>
          <!-- 监管机构 -->
          <li class="active" v-show="this.getsourceType == 4">
            <img class="icon" src="../assets/imgs/index/jgjg.png" />监管机构
          </li>
          <!-- 审核人 -->
          <li class="active" v-show="this.getsourceType == 3">
            <img class="icon" src="../assets/imgs/index/shr.png" />审核人
          </li>
        </ul>
        <div class="tab-content">
          <!-- 企业 -->
          <div
            v-show="
              this.getsourceType == 1 ||
              (this.getsourceType == null && this.cur == 0)
            "
            class="tab_content"
          >
            <img class="main_img" src="../assets/newyearimg/index_qy.png" alt />
            <div class="btn_box1" @click="goApply()">
              <img src="../assets/imgs/gif.gif" alt />
              <span>点击申请</span>
            </div>
          </div>
          <!-- 银行 -->
          <div
            v-show="
              this.getsourceType == 2 ||
              (this.getsourceType == null && this.cur == 1)
            "
            class="tab_content"
          >
            <img class="main_img" src="../assets/imgs/index/bank_content.png" alt />
            <div class="btn_box">
              <div class="box">
                <img src="../assets/imgs/index/5.png" alt />
                <el-button type="primary" @click="demand">需求对接</el-button>
              </div>
              <div class="box">
                <img src="../assets/imgs/index/4.png" />
                <el-button type="primary" @click="recommend">企业推荐</el-button>
              </div>
              <div class="box">
                <img src="../assets/imgs/index/3.png" />
                <el-button type="primary" @click="queryReport()">信用服务</el-button>
              </div>
              <div class="box">
                <img src="../assets/imgs/index/2.png" />
                <el-button type="primary" @click="product">产品管理</el-button>
              </div>
              <div class="box">
                <img src="../assets/imgs/index/1.png" />
                <el-button type="primary" @click="businessReport">业务报送</el-button>
              </div>
            </div>
          </div>
          <!-- 审核人 -->
          <div v-show="this.getsourceType == 3" class="tab_content">
            <div class="btn_box1" style="margin: auto">
              <img
                src="../assets/imgs/index/cliclhSh.png"
                style="margin: 100px 0"
                @click="goAudit()"
              />
              <!-- <img
                src="../assets/imgs/index/cliclhXh.png"
                style="margin:100px 0 "
                @click="auditShow"
              >-->
              <!-- <span>点击申请</span> -->
            </div>
          </div>
          <!-- 监管机构 -->
          <div v-show="this.getsourceType == 4" class="tab_content">
            <img class="main_img" src="../assets/imgs/index/jgjgbg.png" alt />
            <div class="btn_box">
              <div class="box">
                <img src="../assets/imgs/index/4.png" />
                <el-button type="primary" @click="recommended()">客户推荐</el-button>
              </div>
              <div class="box">
                <img src="../assets/imgs/index/sp2x.png" />
                <el-button type="primary" @click="jgproduct">产品审批</el-button>
              </div>
              <div class="box">
                <img src="../assets/imgs/index/tj2x.png" />
                <el-button type="primary" @click="statistical">平台统计</el-button>
              </div>
              <div class="box">
                <img src="../assets/imgs/index/ywsb.png" />
                <el-button type="primary" @click="ReportResults">业务上报</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 线上授权 -->
    <div class="authresults">
      <img class="result_bg" src="../assets/imgs/index/result_bg1.png" />
      <div class="result_data">
        <div class="item1">
          <img class="icon" src="../assets/imgs/auth/yidaima.png" />
          <p>
            <a style="color:black" href="https://credit.suzhou.com.cn/h5/#/form" target="_blank">发布需求</a>
          </p>
        </div>
        <div class="item2">
          <img class="icon" src="../assets/imgs/auth/list.png" />
          <p @click="goSupermarket(8)">产品列表</p>
        </div>
        <div class="item2">
          <img class="icon" src="../assets/imgs/auth/shouquan.png" />
          <p @click="onlineGo(onlineAuth)">线上授权</p>
        </div>
        <div class="item3">
          <img class="icon" src="../assets/imgs/auth/baoxian.png" />
          <p @click="goSupermarket(8)">登录申请</p>
        </div>
      </div>
      <div class="imageQrCode">
        <div class="itemImage bord" style="width: 20%;">
          <img class="result_bg2" src="../assets/home/ydm.png" />
          <div class="textname">易贷码</div>
        </div>
        <div class="itemImage bord" style="width: 30%;">
            <img class="result_bg2" src="../assets/home/zx.png" />
          <div class="textname">征像小程序</div>
        </div>
        <div class="itemImage bord" style="width: 30%;">
          <img class="result_bg2" src="../assets/home/sqr.png" />
          <div class="textname">苏企融小程序</div>
        </div>
        <div class="itemImage" style="width: 20%;">
          <img class="result_bg2" src="../assets/home/xdjsq.png" />
          <div class="textname">信贷计算器</div>
        </div>
      </div>
    </div>
    <!-- 全国信用网站一体化公示专栏 -->
    <div class="nationresults">
      <img class="title" src="../assets/imgs/auth/tititshow.png" />
      <div class="result_data">
        <div class="item1">
          <el-tabs v-model="activeName" style="height: 256px;">
            <el-tab-pane name="xzxk" label="行政许可">
              <ul>
                <li>
                  <a
                    target="_blank"
                    href="https://services.credit.jiangsu.gov.cn:18080/jscredit/xycx/frDetail?searchState=1&amp;entityType=null&amp;keyword=苏州现代货箱码头有限公司&amp;tyshxydm=913205857768698469&amp;jsCreditKey=1cnALZwMWcSUMeQdxdHZ2fglZBHUNdgd4DXtwSHFFcTUBQQ0iA0ZwSwA%2FBTt2Knk7cTIBLgEydEMIJ3FAADIFTXI3CzcDTnFJDDc%3D"
                  >苏州现代货箱码头有限公司</a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://services.credit.jiangsu.gov.cn:18080/jscredit/xycx/frDetail?searchState=1&amp;entityType=null&amp;keyword=阿科玛(常熟)特种材料有限公司&amp;tyshxydm=91320581608253444J&amp;jsCreditKey=1cnALZwMWcSUMeQdxdHZ2fglZBHUNdgd4DXtwSHFFcTUBQQ0iA0ZwSwA%2FBTt2Knk7cTIBLgEydEMIJ3FAADIFTXI3CzcDTnFJDDc%3D"
                  >阿科玛(常熟)特种材料有限公司</a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://services.credit.jiangsu.gov.cn:18080/jscredit/xycx/frDetail?searchState=1&amp;entityType=null&amp;keyword=常熟市机关医务室&amp;tyshxydm=12320581467143339M&amp;jsCreditKey=1cnALZwMWcSUMeQdxdHZ2fglZBHUNdgd4DXtwSHFFcTUBQQ0iA0ZwSwA%2FBTt2Knk7cTIBLgEydEMIJ3FAADIFTXI3CzcDTnFJDDc%3D"
                  >常熟市机关医务室</a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://services.credit.jiangsu.gov.cn:18080/jscredit/xycx/frDetail?searchState=1&amp;entityType=null&amp;keyword=太仓正和国际集装箱码头有限公司&amp;tyshxydm=91320585553759535C&amp;jsCreditKey=1cnALZwMWcSUMeQdxdHZ2fglZBHUNdgd4DXtwSHFFcTUBQQ0iA0ZwSwA%2FBTt2Knk7cTIBLgEydEMIJ3FAADIFTXI3CzcDTnFJDDc%3D"
                  >太仓正和国际集装箱码头有限公司</a>
                </li>
              </ul>
            </el-tab-pane>
            <el-tab-pane name="xzcf" label="行政处罚">
              <ul>
                <li>
                  <a
                    target="_blank"
                    href="https://services.credit.jiangsu.gov.cn:18080/jscredit/xycx/frDetail?searchState=1&amp;entityType=null&amp;keyword=太仓市交运汽车驾驶员培训有限公司&amp;tyshxydm=91320585694535121G&amp;jsCreditKey=1cnALZwMWcSUMeQdxdHZ2fglZBHUNdgd4DXtwSHFFcTUBQQ0iA0ZwSwA%2FBTt2Knk7cTIBLgEydEMIJ3FAADIFTXI3CzcDTnFJDDc%3D"
                  >太仓市交运汽车驾驶员培训有限公司</a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://services.credit.jiangsu.gov.cn:18080/jscredit/xycx/frDetail?searchState=1&amp;entityType=null&amp;keyword=太仓嘉荣建设工程有限公司&amp;tyshxydm=91320585586642405F&amp;jsCreditKey=1cnALZwMWcSUMeQdxdHZ2fglZBHUNdgd4DXtwSHFFcTUBQQ0iA0ZwSwA%2FBTt2Knk7cTIBLgEydEMIJ3FAADIFTXI3CzcDTnFJDDc%3D"
                  >太仓嘉荣建设工程有限公司</a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://services.credit.jiangsu.gov.cn:18080/jscredit/xycx/frDetail?searchState=1&amp;entityType=null&amp;keyword=常熟市鑫鹏机动车驾驶员培训中心有限公司&amp;tyshxydm=91320581MA1WBD0F6T&amp;jsCreditKey=1cnALZwMWcSUMeQdxdHZ2fglZBHUNdgd4DXtwSHFFcTUBQQ0iA0ZwSwA%2FBTt2Knk7cTIBLgEydEMIJ3FAADIFTXI3CzcDTnFJDDc%3D"
                  >常熟市鑫鹏机动车驾驶员培训中心有限公司</a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://services.credit.jiangsu.gov.cn:18080/jscredit/xycx/frDetail?searchState=1&amp;entityType=null&amp;keyword=苏州恒顺机动车驾驶员培训有限公司&amp;tyshxydm=91320594MA1X4K7K30&amp;jsCreditKey=1cnALZwMWcSUMeQdxdHZ2fglZBHUNdgd4DXtwSHFFcTUBQQ0iA0ZwSwA%2FBTt2Knk7cTIBLgEydEMIJ3FAADIFTXI3CzcDTnFJDDc%3D"
                  >苏州恒顺机动车驾驶员培训有限公司</a>
                </li>
              </ul>
            </el-tab-pane>
          </el-tabs>
          <!-- <a @click.prevent="openmoreLink(activeName)" href="#" target="_blank" class="morelink">
            更多
            <i class="el-icon-arrow-right iconstyle"></i>
          </a>-->
          <a
            :href="`https://credit.suzhou.gov.cn/ythgs/gscx?type=${activeName}`"
            target="_blank"
            class="morelink"
          >
            更多
            <i class="el-icon-arrow-right iconstyle"></i>
          </a>
        </div>
        <div class="item2">
          <el-tabs v-model="activeName2" style="height: 256px;">
            <el-tab-pane name="sxjl" :disabled="true" label="诚实守信">
              <ul>
                <li>
                  <a
                    target="_blank"
                    href="https://services.credit.jiangsu.gov.cn:18080/jscredit/xycx/frDetail?searchState=1&amp;entityType=1&amp;keyword=江苏亨通电力电缆有限公司&amp;tyshxydm=91320509628461777A&amp;jsCreditKey=1cnALZwMWcSUMeQdxdHZ2fglZBHUNdgd4DXtwSHFFcTUBQQ0iA0ZwSwA%2FBTt2Knk7cTIBLgEydEMIJ3FAADIFTXI3CzcDTnFJDDc%3D"
                  >江苏亨通电力电缆有限公司</a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://services.credit.jiangsu.gov.cn:18080/jscredit/xycx/frDetail?searchState=1&amp;entityType=1&amp;keyword=苏州万益特医疗用品有限公司&amp;tyshxydm=91320594608205645K&amp;jsCreditKey=1cnALZwMWcSUMeQdxdHZ2fglZBHUNdgd4DXtwSHFFcTUBQQ0iA0ZwSwA%2FBTt2Knk7cTIBLgEydEMIJ3FAADIFTXI3CzcDTnFJDDc%3D"
                  >苏州万益特医疗用品有限公司</a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://services.credit.jiangsu.gov.cn:18080/jscredit/xycx/frDetail?searchState=1&amp;entityType=1&amp;keyword=昆山普罗虎贲升降技术有限公司&amp;tyshxydm=91320583560319482U&amp;jsCreditKey=1cnALZwMWcSUMeQdxdHZ2fglZBHUNdgd4DXtwSHFFcTUBQQ0iA0ZwSwA%2FBTt2Knk7cTIBLgEydEMIJ3FAADIFTXI3CzcDTnFJDDc%3D"
                  >昆山普罗虎贲升降技术有限公司</a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://services.credit.jiangsu.gov.cn:18080/jscredit/xycx/frDetail?searchState=1&amp;entityType=1&amp;keyword=上海春山精密机电有限公司&amp;tyshxydm=91320583MA206J8B6C&amp;jsCreditKey=1cnALZwMWcSUMeQdxdHZ2fglZBHUNdgd4DXtwSHFFcTUBQQ0iA0ZwSwA%2FBTt2Knk7cTIBLgEydEMIJ3FAADIFTXI3CzcDTnFJDDc%3D"
                  >上海春山精密机电有限公司</a>
                </li>
              </ul>
            </el-tab-pane>
          </el-tabs>
          <!-- <a @click.prevent="openmoreLink(activeName2)" href="#" class="morelink">
            更多
            <i class="el-icon-arrow-right iconstyle"></i>
          </a>-->
          <a
            :href="`https://credit.suzhou.gov.cn/ythgs/gscx?type=${activeName2}`"
            target="_blank"
            class="morelink"
          >
            更多
            <i class="el-icon-arrow-right iconstyle"></i>
          </a>
        </div>
        <div class="item3">
          <el-tabs v-model="activeName3" style="height: 256px;">
            <el-tab-pane name="zdsswf" label="重大税收违法案件当事人">
              <ul>
                <li>
                  <a
                    target="_blank"
                    href="https://services.credit.jiangsu.gov.cn:18080/jscredit/xycx/frDetail?searchState=1&amp;entityType=null&amp;keyword=盐城市亮井生态农业有限公司&amp;tyshxydm=null&amp;jsCreditKey=1cnALZwMWcSUMeQdxdHZ2fglZBHUNdgd4DXtwSHFFcTUBQQ0iA0ZwSwA%2FBTt2Knk7cTIBLgEydEMIJ3FAADIFTXI3CzcDTnFJDDc%3D"
                  >盐城市亮井生态农业有限公司</a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://services.credit.jiangsu.gov.cn:18080/jscredit/xycx/frDetail?searchState=1&amp;entityType=null&amp;keyword=宿迁市凌玛酒店管理有限公司&amp;tyshxydm=null&amp;jsCreditKey=1cnALZwMWcSUMeQdxdHZ2fglZBHUNdgd4DXtwSHFFcTUBQQ0iA0ZwSwA%2FBTt2Knk7cTIBLgEydEMIJ3FAADIFTXI3CzcDTnFJDDc%3D"
                  >宿迁市凌玛酒店管理有限公司</a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://services.credit.jiangsu.gov.cn:18080/jscredit/xycx/frDetail?searchState=1&amp;entityType=null&amp;keyword=宿迁天陵建筑工程有限公司&amp;tyshxydm=null&amp;jsCreditKey=1cnALZwMWcSUMeQdxdHZ2fglZBHUNdgd4DXtwSHFFcTUBQQ0iA0ZwSwA%2FBTt2Knk7cTIBLgEydEMIJ3FAADIFTXI3CzcDTnFJDDc%3D"
                  >宿迁天陵建筑工程有限公司</a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://services.credit.jiangsu.gov.cn:18080/jscredit/xycx/frDetail?searchState=1&amp;entityType=null&amp;keyword=睢宁科泰进出口贸易有限公司&amp;tyshxydm=null&amp;jsCreditKey=1cnALZwMWcSUMeQdxdHZ2fglZBHUNdgd4DXtwSHFFcTUBQQ0iA0ZwSwA%2FBTt2Knk7cTIBLgEydEMIJ3FAADIFTXI3CzcDTnFJDDc%3D"
                  >睢宁科泰进出口贸易有限公司</a>
                </li>
              </ul>
            </el-tab-pane>
            <el-tab-pane :disabled="true">
              <span slot="label">
                <a href="http://zxgk.court.gov.cn/shixin/" target="_blank">失信被执行人</a>
              </span>
            </el-tab-pane>
          </el-tabs>
          <!-- <a @click.prevent="openmoreLink(activeName3)" href="#" target="_blank" class="morelink">
            更多
            <i class="el-icon-arrow-right iconstyle"></i>
          </a>-->
          <a
            :href="`https://credit.suzhou.gov.cn/ythgs/gscx?type=${activeName3}`"
            target="_blank"
            class="morelink"
          >
            更多
            <i class="el-icon-arrow-right iconstyle"></i>
          </a>
        </div>
        <div class="item4">
          <el-tabs v-model="activeName4" style="height: 256px;">
            <el-tab-pane name="sxcj" label="严重失信主体名单">
              <ul>
                <li>
                  <a
                    target="_blank"
                    href="https://services.credit.jiangsu.gov.cn:18080/jscredit/xycx/frDetail?searchState=1&amp;entityType=1&amp;keyword=张家港美铝铝业有限公司&amp;tyshxydm=91320582MA1NQQPJ7N&amp;jsCreditKey=1cnALZwMWcSUMeQdxdHZ2fglZBHUNdgd4DXtwSHFFcTUBQQ0iA0ZwSwA%2FBTt2Knk7cTIBLgEydEMIJ3FAADIFTXI3CzcDTnFJDDc%3D"
                  >张家港美铝铝业有限公司</a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://services.credit.jiangsu.gov.cn:18080/jscredit/xycx/frDetail?searchState=1&amp;entityType=5&amp;keyword=苏州市水产协会&amp;tyshxydm=5132050050977536XU&amp;jsCreditKey=1cnALZwMWcSUMeQdxdHZ2fglZBHUNdgd4DXtwSHFFcTUBQQ0iA0ZwSwA%2FBTt2Knk7cTIBLgEydEMIJ3FAADIFTXI3CzcDTnFJDDc%3D"
                  >苏州市水产协会</a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://services.credit.jiangsu.gov.cn:18080/jscredit/xycx/frDetail?searchState=1&amp;entityType=5&amp;keyword=苏州市乐掼扑克运动俱乐部&amp;tyshxydm=52320500MJ6616163B&amp;jsCreditKey=1cnALZwMWcSUMeQdxdHZ2fglZBHUNdgd4DXtwSHFFcTUBQQ0iA0ZwSwA%2FBTt2Knk7cTIBLgEydEMIJ3FAADIFTXI3CzcDTnFJDDc%3D"
                  >苏州市乐掼扑克运动俱乐部</a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://services.credit.jiangsu.gov.cn:18080/jscredit/xycx/frDetail?searchState=1&amp;entityType=5&amp;keyword=苏州美育非物质文化遗产青少年发展中心&amp;tyshxydm=52320500329598714A&amp;jsCreditKey=1cnALZwMWcSUMeQdxdHZ2fglZBHUNdgd4DXtwSHFFcTUBQQ0iA0ZwSwA%2FBTt2Knk7cTIBLgEydEMIJ3FAADIFTXI3CzcDTnFJDDc%3D"
                  >苏州美育非物质文化遗产青少年发展中心</a>
                </li>
              </ul>
            </el-tab-pane>
          </el-tabs>
          <!-- <a @click.prevent="openmoreLink(activeName4)" href="#" class="morelink">
            更多
            <i class="el-icon-arrow-right iconstyle"></i>
          </a>-->
          <a
            :href="`https://credit.suzhou.gov.cn/ythgs/gscx?type=${activeName4}`"
            target="_blank"
            class="morelink"
          >
            更多
            <i class="el-icon-arrow-right iconstyle"></i>
          </a>
        </div>
      </div>
    </div>
    <!-- 平台成效展示 -->
    <div class="results">
      <img class="title" src="../assets/imgs/index/result_title.png" />
      <img class="result_bg" src="../assets/imgs/index/result_bg1.png" />
      <div class="result_data">
        <div class="item1">
          <img class="icon" src="../assets/imgs/index/result1.png" />
          <p>实名认证企业</p>
          <!-- <p class="datas">{{ result.registeredEnterpriseNum }}</p> -->
          <p class="datas">{{result.enterpriseNum}}万</p>
        </div>
        <div class="item2">
          <img class="icon" src="../assets/imgs/index/result2.png" />
          <p>企业获贷总额</p>
          <p class="datas">{{result.loanAmount}}亿</p>
          <!-- <p>
            <span>{{ needsAmount }}</span>
          </p>-->
        </div>
        <div class="item2">
          <img class="icon" src="../assets/imgs/index/result3.png" />
          <p>信用贷款总额</p>
          <p class="datas">{{result.loanAmountAssured}}亿</p>
          <!-- <p>
            平台放款金额（元）
            <span>{{ loanAmount }}</span>亿+
          </p>-->
        </div>
        <div class="item3">
          <img class="icon" src="../assets/imgs/index/result4.png" />
          <p>入驻金融机构</p>
          <p>
            <span>{{result.financeSum}}</span>
          </p>
        </div>
      </div>
    </div>
    <!-- 区域数据 -->
    <div class="area">
      <img class="bg" src="../assets/imgs/index/result_bg2.png" />
      <div class="area_box">
        <div class="item" :key="index" v-for="(item, index) in resultList">
          <img class="item_bg" :src="baseUrl + item.img" />
          <p class="city">{{ item.area }}</p>
          <div class="datas">
            <div class="bus">
              <p>放款企业</p>
              <p class="num">{{ item.loanEnterpriseNum }}</p>
            </div>
            <div class="bus">
              <p>放款金额</p>
              <p class="num">{{ item.loanAmount }}亿+</p>
              <!-- <p class="num">{{ item.loanAmount }}万</p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 特色品牌 -->
    <div class="brand">
      <div style="width: 1280px; height: 100%; margin: 0 auto">
        <img class="title" src="../assets/imgs/index/brand_title.png" alt />
        <div class="xydtspp">
          <div class="xydtspp1">
            <img class="titleImage" src="../assets/home/sb.png" alt />
          </div>
          <div class="xydtspp2">
            <img class="titleImage" src="../assets/home/pb.png" alt />
          </div>
          <div class="xydtspp3">
            <img class="titleImage" src="../assets/home/kb.png" alt />
          </div>
        </div>
        <div class="brand_box">
          <el-carousel indicator-position="outside">
            <el-carousel-item v-for="(item, index) in getDataList" :key="index">
              <div
                v-for="obj in item"
                :key="obj.name"
                class="item"
                :style="getStyle(obj)"
                @click="productDetail(obj.count, obj.typeId)"
              >
                <img :src="baseUrl + obj.imageUrl" alt />
                <div class="name">{{ obj.name }}</div>
                <div class="describe">{{ obj.describe }}</div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <!-- 常见问题 -->
    <div class="question">
      <div style="width: 1280px; height: 100%; margin: 0 auto" @click="commonProductShow">
        <img class="title" src="../assets/imgs/index/question_title.png" alt />
        <div class="question_box">
          <div class="left">
            <img class="left1" src="../assets/imgs/index/question_left1.png" />
            <div class="left_item">
              <img class="img" src="../assets/imgs/index/question_left.png" />
              <div class="text">
                <div>什么是“一键授信”产品？</div>
              </div>
            </div>
            <div class="left_item">
              <img class="img" src="../assets/imgs/index/question_left.png" />
              <div class="text">
                <div>我不是企业法人能够注册吗？</div>
              </div>
            </div>
            <div class="left_item" style="margin-top: 10px">
              <img class="img" src="../assets/imgs/index/banckg.png" />
            </div>
          </div>
          <div class="right">
            <div class="left_item">
              <img class="img" src="../assets/imgs/index/question_right.png" />
              <div class="text">
                <div>融资对接过程中会不会产生中介费用？</div>
              </div>
            </div>
            <div class="left_item">
              <img class="img" src="../assets/imgs/index/question_right.png" />
              <div class="text">
                <div>企业提交的相关信息会不会被泄露？</div>
              </div>
            </div>
            <div class="left_item">
              <img class="img" src="../assets/imgs/index/question_right.png" />
              <div class="text">
                <div>融资需求提交后金融机构如何联系我？</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 合作机构 -->
    <div class="cooperation">
      <div style="width: 1280px; height: 100%; margin: 0 auto">
        <img class="title" src="../assets/imgs/index/cooperation_title.png" />
        <div class="cooperation_box">
          <img v-for="(item, index) in cooperationList" :key="index" :src="baseUrl + item.img" />
        </div>
      </div>
    </div>
    <!-- 友情链接 -->
    <div class="links">
      <div style="width: 1280px; height: 100%; margin: 0 auto">
        <img class="title" src="../assets/imgs/index/links_title.png" />
        <div class="links_box">
          <ul>
            <li>
              <a href="https://www.celoan.cn/" target="_blank">· 全国中小企业融资综合信用服务示范平台</a>
            </li>
            <li>
              <a href="https://www.szqyzx.com.cn/" target="_blank">· 信用苏州</a>
            </li>
            <li v-if="false">
              <a href=" https://www.szgqfw.com/" target="_blank">· 苏州股权融资服务平台</a>
            </li>
          </ul>
          <ul>
            <li>
              <a href="https://www.jssjrfw.com/#/home" target="_blank">· 江苏省综合金融服务平台</a>
            </li>
            <li>
              <a href="https://www.szqyzx.com.cn/" target="_blank">· 征信苏州</a>
            </li>
          </ul>
          <ul>
            <li>
              <a href="https://jsceloan.jssjrfw.com/#/celoan" target="_blank">· 江苏省信易贷平台</a>
            </li>
          </ul>
          <ul>
            <li>
              <a href="https://www.szjrfw.com/" target="_blank">· 苏州企业金融服务超市</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 易贷码 -->
    <!-- <el-dialog title="易贷码" :visible.sync="yiCode" width="40%">
      <div style="text-align: center;">
       
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="yiCode = false">取 消</el-button>
      </span>
    </el-dialog>-->

    <el-dialog
      :visible.sync="auditVisible"
      width="35%"
      custom-class="myDialog"
      :show-close="false"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :lock-scroll="false"
      :modal-append-to-body="false"
    >
      <div class="audit">
        <div class="a1">上报平台成效</div>
        <div class="a4">
          <div class="b1">
            请点击上传
            <el-upload class="upload-demo" accept=".xlsx, .xls" action>
              <a>选择文件</a>
            </el-upload>
          </div>
          <div class="b2">*仅支持上传xls/xlsx文件</div>
          <div class="b3">
            <img src="@/assets/images/excel.png" alt />
            <div>{{ this.Name }}</div>
          </div>
        </div>
        <div>
          <el-button class="myButton" @click="auditVisible = false">取消</el-button>
          <el-button type="primary" class="myPrimaryButton">上传</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      width="35%"
      :visible.sync="reportVisible"
      custom-class="myDialog"
      :show-close="false"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :lock-scroll="false"
      :modal-append-to-body="false"
    >
      <div class="content">
        <div class="a1">{{ year }}年{{ month }}月信易贷业务报送</div>
        <div class="a2">截止时间：{{ year }}年{{ month }}月{{ days }}日</div>
        <div class="a3">
          <img src="@/assets/images/excel.png" alt />
          <div>
            信易贷报送模板
            <span @click="xiazai" style="color: blue">下载</span>
          </div>
        </div>
        <div class="a4">
          <div class="b1">
            请点击上传
            <el-upload
              class="upload-demo"
              :action="xslUrl"
              :headers="headers"
              :data="params"
              accept=".xlsx, .xls"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :auto-upload="false"
              ref="upload"
              :on-change="handName"
            >
              <a>选择文件</a>
            </el-upload>
          </div>
          <div class="b2">*仅支持上传xls/xlsx文件</div>
          <div class="b3">
            <img src="@/assets/images/excel.png" alt />
            <div>{{ this.Name }}</div>
          </div>
        </div>
        <div>
          <el-button class="myButton" @click="handleCancel">取消</el-button>
          <el-button class="myMainButton" @click="goHistory">查看记录</el-button>
          <el-button type="primary" class="myPrimaryButton" @click="handleUpload">上传</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      width="25%"
      :visible.sync="recordVisible"
      custom-class="myDialog"
      :show-close="false"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :lock-scroll="false"
    >
      <div class="content">
        <img class="a6" src="../assets/images/warning.png" alt />
        <div class="a7">您未报送上月度信易贷业务</div>
        <div class="a7">本机构所有用户相关功能已暂停服务</div>
        <div style="margin-top: 10px">
          <el-button class="myButton" @click="handleCancel">取消</el-button>
          <el-button type="primary" class="myPrimaryButton">补录业务</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      width="300px"
      :visible.sync="successVisible"
      custom-class="myDialog"
      :show-close="false"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :lock-scroll="false"
    >
      <div class="content">
        <img class="a8" src="../assets/images/success.png" alt />
        <div class="a9">{{ reason }}</div>
        <el-button
          style="margin-top: 10px"
          type="primary"
          class="myPrimaryButton"
          @click="handleSubmit"
        >确认</el-button>
      </div>
    </el-dialog>
    <el-dialog
      width="300px"
      :visible.sync="errorVisible"
      custom-class="myDialog"
      :show-close="false"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :lock-scroll="false"
    >
      <div class="content">
        <img class="a8" src="../assets/images/error.png" alt />
        <div class="a9">上传失败</div>
        <div class="a5">检测到错误：{{ this.reason }}</div>
        <el-button
          style="margin-top: 20px"
          type="primary"
          class="myPrimaryButton"
          @click="handleSubmit"
        >确认</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="常见问题"
      :visible.sync="commonProduct"
      width="50%"
      :show-close="false"
      :close-on-click-modal="false"
      center
      custom-class="Popups"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :popper-append-to-body="true"
    >
      <div class="box" v-for="(item, index) in commonProductList" :key="index">
        <div class="header">{{ item.name }}</div>
        <div class="midden">{{ item.details }}</div>
      </div>
      <div class="btn">
        <el-button type="primary" @click="commonProduct = false">确 定</el-button>
      </div>
    </el-dialog>
    <div class="imgsss"></div>
    <el-dialog
      width="686px"
      :visible.sync="libaoVisible"
      custom-class="libaoDialog"
      :show-close="false"
      :destroy-on-close="true"
      :lock-scroll="false"
      :modal-append-to-body="true"
    >
      <img src="../assets/newyearimg/libao.png" alt />
      <span @click="getLibao2">点击领取</span>
    </el-dialog>
    <el-dialog
      width="400px"
      :visible.sync="libaoVisible2"
      custom-class="libaoDialog"
      :show-close="false"
      :destroy-on-close="true"
      :lock-scroll="false"
      :modal-append-to-body="true"
    >
      <div>
        <h2>请扫码下载苏商通APP领取礼包</h2>
        <img src="../assets/newyearimg/saoma.png" alt />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as indexApi from "@/api/index";
import { user } from "@/api/login";
import router from "../router";
import baseUrl from "@/api/baseUrl";
import { get } from "../utils/request";
import Swiper from "swiper/js/swiper";
export default {
  data() {
    return {
      showDone: false,
      // yiCode: false,
      libaoVisible: false,
      libaoVisible2: false,
      libaoVisible3: false,
      activeName: "xzxk", //一体化公式栏tabs
      activeName2: "sxjl", //一体化公式栏tabs
      activeName3: "zdsswf", //一体化公式栏tabs
      activeName4: "sxcj", //一体化公式栏tabs
      cur: 0, // 企业0 银行1
      result: {}, //平台成功展示
      needsAmount: null,
      loanAmount: null,
      resultList: [], //区域数据
      list: [],
      cooperationList: [], //合作机构图片列表
      code: "",
      status: false,
      reportVisible: false,
      recordVisible: false,
      successVisible: false,
      errorVisible: false,
      bankStatus: "",
      business: "",
      dock: "",
      page: 1,
      pageSize: 5,
      pageList: [],
      totalPage: undefined,
      xslUrl: baseUrl + "/api/v1/file/upload",
      headers: {
        token: sessionStorage.getItem("token")
      },
      params: {
        type: 7
      },
      productInfoList: [],
      commonProduct: false,
      commonProductList: [
        {
          name: "1.什么是“一键授信”产品",
          details:
            "一键授信系列产品通过大数据精准建模，实现企业融资需求智能匹配、线上快速测额，提供便捷、优惠、多样的线上融资服务。"
        },
        {
          name: "2.融资对接过程中会不会产生中介费用？",
          details: "本平台不向企业和金融机构收取任何中介费用。"
        },
        {
          name: "3.我不是企业法定代表人能够注册吗？",
          details:
            "如果您不是企业法定代表人，则需要企业的法定代表人在苏商通平台对您进行授权后，方能与企业绑定成功。"
        },
        {
          name: "4.企业提交的相关信息会不会被泄露？",
          details:
            "本平台采取严格的信息安全保障机制，确保您的信息不被泄露给第三方。"
        },
        {
          name: "5.融资需求提交后金融机构如何联系我？",
          details: "金融机构将通过您注册账号时使用的手机号码联系您。"
        }
      ],
      year: "",
      month: "",
      days: "",
      Name: "",
      reason: "",
      getBankAuth: sessionStorage.getItem("bankAuth"),
      getsourceType: sessionStorage.getItem("sourceType"),
      scrollTop: 0,
      auditVisible: false,
      deptId: ""
    };
  },
  mounted() {
    let time = new Date();
    this.year = time.getFullYear();
    this.month = time.getMonth() + 1;
    if (this.month.toString().length == 1) {
      this.month = "0" + this.month;
    }

    function getCountDays() {
      var curDate = new Date();
      var curMonth = curDate.getMonth();
      curDate.setMonth(curMonth + 1);
      curDate.setDate(0);
      return curDate.getDate();
    }

    this.days = getCountDays();
    let activity = sessionStorage.getItem("activity");
    // if (activity !== '1') {
    //   this.openZheZhao()
    // }
    //活动
    setTimeout(() => {
      this.swiper1();
    }, 5000);
  },
  created() {
    this.code = this.$route.query.code;
    // console.log(this.code, "useruseruser");

    this.status = this.$route.params.status;
    if (this.status || this.code !== undefined) {
      const token = sessionStorage.getItem("token");
      if (!token) {
        this.getUser();
      } else {
        this.doOther();
      }
    }

    if (sessionStorage.getItem("bankAuth")) {
      let backId = sessionStorage.getItem("bankAuth");
      let index = backId.indexOf(1);
      if (index !== -1) {
        this.bankStatus = 1;
        this.cur = 1;
      }
      let index1 = backId.indexOf(3);
      if (index1 !== -1) {
        this.dock = 3;
        this.cur = 1;
      }
      let index2 = backId.indexOf(2);
      if (index2 !== -1) {
        this.business = 2;
        this.cur = 1;
      }
    }
    this.deptId = sessionStorage.getItem("deptId");
    this.getResultData();
    this.getCooperationList();
    this.productInfo();

    this.libaoVisible3 = new Date().getTime() >= 1644508800000;
  },
  computed: {
    getTop: function() {
      return document.scrollingElement.scrollTop + 608;
    },
    getDataList() {
      const newArr = [];
      let arr = [];
      for (let j = 0; j < 4; j++) {
        for (let i = 0; i < this.productInfoList.length; i++) {
          if (arr.length < 4) {
            arr.push(this.productInfoList[i]);
          } else {
            newArr.push([].concat(arr));
            arr = [this.productInfoList[i]];
          }
        }
      }
      if (arr.length) newArr.push(arr);
      return newArr;
    }
  },

  methods: {
    // 易贷码授权
    // qrCode() {
    //   this.yiCode = true;
    // },
    // 产品列表
    goSupermarket(id) {
      this.$router.push({
        path: "/xyd/Supermarket",
        query: {
          id: id
        }
      });
    },
    // 线上授权
    onlineGo() {
      const onlinePath = this.$router.resolve({
        name: "onlineAuth"
      });
      window.open(onlinePath.href, "_blank");
    },
    // 公示栏
    // openmoreLink(type) {
    //   const path = this.$router.resolve({
    //     path: "https://credit.suzhou.gov.cn/ythgs/gscx?type",
    //     query: { type }
    //   }).href;
    //   window.open(path, "_blank");
    // },

    swiper1() {
      new Swiper(this.$refs.mySwiper1, {
        effect: "fade",

        loop: true,
        autoplay: {
          delay: 5000
        }
        // loopFillGroupWithBlank: true,
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true,
        // },
        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev",
        //   disabledClass: "my-button-disabled",
        // },
      });
    },
    // 跳转fangy
    tofangyi() {
      // this.$router.push("/xyd/fangyihome");
    },
    toszrmb() {
      this.$router.push("/xyd/numberyuan");
    },
    tohqlb(e) {
      this.$router.push("/xyd/newyearbiggift");
    },
    getLibao() {
      this.libaoVisible = true;
    },
    getLibao2() {
      this.libaoVisible = false;
      this.libaoVisible2 = true;
    },
    getStyle(item) {
      return {
        backgroundImage: "url(" + baseUrl + item.background + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100%"
      };
    },
    auditShow() {
      this.auditVisible = true;
    },
    shutDown() {
      var x = document.getElementsByClassName("zhezhao");
      x[0].style.display = "none";
      document.documentElement.style.overflow = "auto";
    },
    openZheZhao() {
      var x = document.getElementsByClassName("zhezhao");
      x[0].style.display = "block";
      var y = document.getElementsByClassName("imgsss");
      if (this.getTop < 2300) {
        y[0].style.top = this.getTop + "px";
      }
      document.documentElement.style.overflow = "hidden";
      sessionStorage.setItem("activity", 1);
    },
    doOther() {
      this.cur = 0;
      let sourceType = sessionStorage.getItem("sourceType");
      if (sourceType) {
        if (sourceType == 2) {
          this.cur = 1;
        }
      }
      let bankAuth = sessionStorage.getItem("bankAuth");
      if (bankAuth) {
        let index = bankAuth.indexOf(1);
        if (index !== -1) {
          this.bankStatus = 1;
        }
        let index1 = bankAuth.indexOf(3);
        if (index1 !== -1) {
          this.dock = 3;
        }
        let index2 = bankAuth.indexOf(2);
        if (index2 !== -1) {
          this.business = 2;
        }
      }
    },
    handName(res, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      this.Name = res.name;
    },
    xiazai() {
      const xhr = new XMLHttpRequest();
      xhr.open("get", this.baseUrl + "/api/v1/file/reportTemplateExcel", true); // get、post都可
      xhr.responseType = "blob"; // 转换流
      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
      xhr.setRequestHeader(
        "Content-Type",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
      );
      xhr.onload = function() {
        if (this.status === 200) {
          // const blob = this.response;
          const blob = this.response;
          const fileName = "信易贷报送模板文档.xlsx";
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            const a = document.createElement("a");
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        }
      };
      xhr.send();
    },
    commonProductShow() {
      this.commonProduct = true;
    },
    statistical() {
      sessionStorage.setItem("currentTab", "resultStatistics");
      this.$router.push("/xyd/my_center");
    },
    ReportResults() {
      sessionStorage.setItem("currentTab", "ReportResults");
      sessionStorage.setItem("status", "1");
      this.$router.push({
        path: "/xyd/my_center"
      });
    },
    jgproduct() {
      if (this.deptId === "5") {
        sessionStorage.setItem("currentTab", "productApproval");
        this.$router.push("/xyd/my_center");
      } else {
        this.$message.error("本账号无权限");
      }
    },
    recommended() {
      if (this.deptId === "5") {
        sessionStorage.setItem("currentTab", "recommendedEnterprise");
        this.$router.push("/xyd/my_center");
      } else {
        this.$message.error("本账号无权限");
      }
    },
    goAudit() {
      sessionStorage.setItem("currentTab", "reviewWait");
      this.$router.push("/xyd/my_center");
    },
    productInfo() {
      indexApi.productInfoList().then(res => {
        res = this.paramDecrypt(res);
        if (res.code == 200) {
          this.productInfoList = res.data;
        }
      });
    },
    handleAvatarSuccess(res) {
      if (res.code == 200) {
        this.reason = res.msg;
        this.reportVisible = false;
        this.successVisible = true;
      } else {
        this.reason = res.msg;
        this.reportVisible = false;
        this.errorVisible = true;
      }
    },
    //产品超市
    getPageList() {
      let params = {
        page: this.page,
        pageSize: this.pageSize,
        status: 2
      };

      indexApi
        .pageList(this.sendParam(params))
        .then(res => {
          res = this.paramDecrypt(res);
          if (res.code == 200) {
            this.pageList = res.data;
            this.totalPage = res.pageInfo.totalPage;
          }
        })
        .catch(err => {});
    },
    handerChange() {
      if (this.page >= this.totalPage) {
        this.page = 1;
        this.getPageList();
        return;
      } else {
        this.page++;
        this.getPageList();
        return;
      }
    },
    goHistory() {
      //查看历史上报记录
      sessionStorage.setItem("currentTab", "BusinessReport");
      this.$router.push("/xyd/my_center");
    },
    // 银行业务上报
    businessReport() {
      const token = sessionStorage.getItem("token");
      const sourceType = sessionStorage.getItem("sourceType");
      if (token) {
        if (sourceType == "2") {
          if (this.business == 2 || this.bankStatus == 1) {
            this.reportVisible = true;
            this.Name = "";
          } else {
            this.$message.error("本账号暂无权限");
          }
        } else {
          this.$message.error("本账号暂无权限");
        }
      } else {
        this.$router.push("/xyd/login");
      }
    },
    demand() {
      const token = sessionStorage.getItem("token");
      const sourceType = sessionStorage.getItem("sourceType");
      if (token) {
        if (sourceType == "2") {
          if (this.bankStatus == 1 || this.dock == 3) {
            this.$router.push("/xyd/my_center");
            sessionStorage.setItem("currentTab", "financeProduct");
            return;
          }
          this.$message.error("本账号暂无权限");
          return;
        }
        this.$message.error("本账号暂无权限");
      } else {
        this.$router.push("/xyd/login");
      }
    },
    recommend() {
      const token = sessionStorage.getItem("token");
      if (token) {
        const sourceType = sessionStorage.getItem("sourceType");
        if (sourceType == "2") {
          this.$router.push("/xyd/my_center");
          sessionStorage.setItem("currentTab", "customerRecommend");
        }
      } else {
        this.$router.push("/xyd/login");
      }
    },
    product() {
      const token = sessionStorage.getItem("token");
      if (token) {
        const sourceType = sessionStorage.getItem("sourceType");
        if (sourceType == "2") {
          this.$router.push("/xyd/my_center");
          sessionStorage.setItem("currentTab", "publishProduct");
        }
      } else {
        this.$router.push("/xyd/login");
      }
    },
    handleCancel() {
      this.reportVisible = false;
      this.recordVisible = false;
    },
    handleUpload() {
      this.$refs.upload.submit();
      // this.errorVisible = true;
    },
    handleSubmit() {
      this.successVisible = false;
      this.errorVisible = false;
    },
    async getUser() {
      let param = {
        code: this.code
      };
      // console.log(param, "71162527c061251abfb09e80a85f2e08");

      const res = await user(this.sendParam(param));
      let result = this.paramDecrypt(res);
      console.log(res);
      console.log(result.data);
      if (result.code == 200) {
        if (result.data.bankAuth) {
          // 银行
          if (result.data.bankAuth.isStop == 0) {
            sessionStorage.removeItem("currentTab");
            sessionStorage.setItem("user", JSON.stringify(result.data));
            sessionStorage.setItem("token", result.data.token);
            this.headers.token = result.data.token;
            this.$store.commit(
              "setSourceType",
              result.data.sstCustom.sourceType
            );
            this.getsourceType = result.data.sstCustom.sourceType;
            this.$store.commit("setUserName", result.data.sstCustom.ouname);
            if (result.data.bankAuth.roleId) {
              this.$store.commit("setBankAuth", result.data.bankAuth.roleId);
              this.getBankAuth = result.data.bankAuth.roleId;
              let index = result.data.bankAuth.roleId.indexOf(1);
              if (index !== -1) {
                this.bankStatus = 1;
                this.cur = 1;
              }
              let index1 = result.data.bankAuth.roleId.indexOf(3);
              if (index1 !== -1) {
                this.dock = 3;
                this.cur = 1;
              }
              let index2 = result.data.bankAuth.roleId.indexOf(2);
              if (index2 !== -1) {
                this.business = 2;
                this.cur = 1;
              }
            }
            this.$emit("myChange");
          } else if (result.data.bankAuth.isStop == 1) {
            this.$message.error("该账户已停用,请更换账户登录");
          }
        } else {
          // 企业
          sessionStorage.removeItem("currentTab");
          sessionStorage.setItem("user", JSON.stringify(result.data));
          sessionStorage.setItem("token", result.data.token);
          this.$store.commit("setSourceType", result.data.sstCustom.sourceType);
          this.getsourceType = result.data.sstCustom.sourceType;
          this.$store.commit("setUserName", result.data.sstCustom.ouname);
          this.$emit("myChange");
        }
      } else {
        this.$message.error(result.msg);
      }
      this.doOther();
    },
    //获取平台展示数据
    getResultData() {
      indexApi.getResultData().then(res => {
        if (res.data.code == 200) {
          this.result = res.data.data.one;
          this.resultList = res.data.data.list;
          this.needsAmount = Math.floor(
            this.result.financingNeedsAmount / 10000
          );
          this.loanAmount = Math.floor(this.result.loanAmount / 10000);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    //获取合作机构数据
    getCooperationList() {
      indexApi.getCooperationList().then(res => {
        if (res.data.code == 200) {
          this.cooperationList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    //申请贷款
    goApply() {
      const token = sessionStorage.getItem("token");
      if (token) {
        const sourceType = sessionStorage.getItem("sourceType");
        if (sourceType == 1) {
          this.$router.push({
            path: "apply_loan"
          });
        } else {
          this.$message.error("本账号暂无权限");
        }
      } else {
        this.$router.push("/xyd/login");
      }
    },
    //去产品超市
    goView() {
      this.$router.push("/xyd/Supermarket");
    },
    //查询报告
    queryReport() {
      const token = sessionStorage.getItem("token");
      const sourceType = sessionStorage.getItem("sourceType");
      if (token && (sourceType === "2" || sourceType === "4")) {
        this.$router.push({
          path: "publicCredit"
        });
      } else {
        if (token) {
          this.$message.error("本账号暂无权限");
        } else {
          this.$message.error("请先登录");
          this.$router.push("/xyd/login");
        }
      }
    },

    //去特色品牌
    goBrand(path) {
      this.$router.push(path);
    },
    change(type) {
      this.$refs["carousel"][type]();
    },

    productDetail(count, id) {
      if (count == 1) {
        this.$router.push({
          path: "/xyd/product_details",
          query: {
            id: id
          }
        });
      } else {
        this.$router.push({
          path: "/xyd/Supermarket",
          query: {
            id: id
          }
        });
      }
    }
  }
};
</script>
<style lang="less">
// .index {
//   filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
//   -webkit-filter: grayscale(100%);
// }
.Popups {
  background-color: #f2f3f3;
  box-sizing: border-box;
  .box {
    margin-top: 18px;
    min-height: 86px;
    width: 100%;
    background-color: #fff;
    padding: 17px;
    box-sizing: border-box;
    .header {
      font-size: 20px;
      font-family: Alibaba PuHuiTi;
      font-weight: 500;
      color: #2a2a2a;
    }
    .midden {
      margin-top: 5px;
      font-size: 16px;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      color: #2a2a2a;
    }
  }
  .btn {
    margin-top: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
</style>
<style lang="less" scoped>
.brand_box {
  /deep/.el-carousel__item {
    display: flex;
    .item {
      width: 320px;
      height: 220px;
      padding: 35px;
      box-sizing: border-box;
      text-align: left;
      margin: 0 10px;
      cursor: pointer;
      img {
        width: 46px;
        height: 46px;
        margin-bottom: 6px;
      }
      .name {
        color: #00479f;
        font-weight: bold;
        font-family: Alibaba PuHuiTi;
        font-size: 20px;
        margin-bottom: 6px;
      }
      .describe {
        color: #2a2a2a;
      }
      &:hover {
        transform: scale(1.2);
        box-shadow: 2px 2px 10px rgba(255, 255, 255, 0.4);
      }
    }
  }
}
ul li {
  margin: 0;
  padding: 0;
  list-style: none;
}
.index {
  position: relative;
  .swiper-wrapper{
    background: #fff !important;
  }
  .zhezhao {
    width: 100vw;
    height: 100%;
    position: absolute;
    background-color: #ccc;
    opacity: 0.4;
    z-index: 3000;
    overflow: hidden;
    display: none;
    .imgsss {
      width: 100%;
      height: 300px;
      background: #000;
      z-index: 3;
      position: absolute;
      top: 608px;
    }
  }
  .appcode {
    position: fixed;
    top: 110px;
    z-index: 1000;
    left: 50px;
  }
  .gift_box {
    position: fixed;
    top: 120px;
    right: 150px;
    z-index: 1000;
    img {
      margin-bottom: 20px;
      cursor: pointer;
    }
  }
  .slideshow {
    width: 100%;
    height: 325px;
    overflow: hidden;
    position: relative;
  }
  .slideshow-image {
    // position: absolute;
    width: 100%;
    height: 100%;
    background: no-repeat 50% 50%;
    background-size: cover;
    // animation-timing-function: linear;
    // animation-iteration-count: infinite;
    // animation-duration: 18s;
    opacity: 1;
  }

  .slideshow-image:nth-child(4) {
    animation-name: kenburns-1;
  }
  .slideshow-image:nth-child(3) {
    animation-name: kenburns-2;
  }
  .slideshow-image:nth-child(2) {
    animation-name: kenburns-3;
  }
  .slideshow-image:nth-child(1) {
    animation-name: kenburns-4;
  }

  @keyframes kenburns-1 {
    0% {
      opacity: 1;
    }
    29% {
      opacity: 1;
    }
    33% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }

  @keyframes kenburns-2 {
    0%,
    25% {
      opacity: 1;
    }
    63% {
      opacity: 1;
    }
    67% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }

  @keyframes kenburns-3 {
    0%,
    59% {
      opacity: 1;
    }
    96% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  @keyframes kenburns-4 {
    0%,
    92% {
      opacity: 1;
    }
    100% {
      opacity: 1;
    }
  }
  .user {
    position: relative;
    height: 330px;
    // margin-bottom: 30px;
    .lipin {
      position: absolute;
      right: 0;
      bottom: 40px;
      z-index: 1000;
      .btn {
        img {
          width: 140px;
          height: 80px;
        }
      }
      .midden {
        position: absolute;
        top: -5px;
        left: -5px;

        img {
          width: 100px;
          height: 100px;
        }
      }
      .box {
        position: absolute;
        top: 7px;
        right: 10px;
        width: 55px;
        height: 55px;
        background-image: url("../assets/newyearimg/libao_click.png");
        background-size: 100%;
        background-repeat: no-repeat;
        animation-name: scaleDraw; /*关键帧名称*/
        animation-timing-function: ease-in-out; /*动画的速度曲线*/
        animation-iteration-count: infinite; /*动画播放的次数*/
        animation-duration: 3s; /*动画所花费的时间*/
        cursor: pointer;
        // img {
        //   width: 60px;
        //   height: 60px;
        // }
      }
      @keyframes scaleDraw {
        /*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/
        0% {
          transform: scale(1); /*开始为原始大小*/
        }
        25% {
          transform: scale(1.1); /*放大1.1倍*/
        }
        50% {
          transform: scale(1);
        }
        75% {
          transform: scale(1.1);
        }
      }
    }

    .tabs {
      width: 1280px;
      height: 100%;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      border-radius: 20px 20px 0 0;

      .tab-tilte {
        width: 100%;
        height: 60px;
        margin: 0 !important;
        padding: 0 !important;
      }
      .tab-tilte .selectedActive {
        background: linear-gradient(189deg, #589dff, #81c3ff, #67b9ff);
        color: #fff;
        float: left;
        width: 100%;
        height: 60px;
        line-height: 60px;
        background-color: #f4f4f4;
        border-radius: 20px 20px 0 0;
        cursor: pointer;
        font-size: 24px;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #6d6f72;
        display: flex;
        justify-content: center;

        .icon {
          width: 55px;
          height: 55px;
          margin-top: 4px;
        }
      }
      .tab-tilte .active1 {
        float: left;
        width: 50%;
        height: 60px;
        line-height: 60px;
        background-color: #f4f4f4;
        border-radius: 20px 20px 0 0;
        cursor: pointer;
        font-size: 24px;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #6d6f72;
        display: flex;
        justify-content: center;

        .icon {
          width: 55px;
          height: 55px;
          margin-top: 4px;
        }
      }

      /* 点击对应的标题添加对应的背景颜色 */

      .tab-tilte .active {
        background: linear-gradient(189deg, #589dff, #81c3ff, #67b9ff);
        color: #fff;
        float: left;
        width: 100%;
        height: 60px;
        line-height: 60px;
        background-color: #f4f4f4;
        border-radius: 20px 20px 0 0;
        cursor: pointer;
        font-size: 24px;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #6d6f72;
        display: flex;
        justify-content: center;

        .icon {
          width: 55px;
          height: 55px;
          margin-top: 4px;
        }
      }

      .tab-content .tab_content {
        height: 240px;
        background-color: #fff;
        text-align: center;
        border-bottom-right-radius: 16px;
        border-bottom-left-radius: 16px;

        .main_img {
          margin-top: 20px;
          //width: 80%;
          height: 170px;
        }

        .btn_box {
          padding: 0 180px 0 160px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          box-sizing: border-box !important;
          margin-top: -30px;
          .box {
            position: relative;
            height: 50px;
            img {
              position: absolute;
              width: 16px;
              height: 16px;
              top: 10px;
              left: 18px;
            }
            .el-button {
              width: 120px;
              text-align: right;
              height: 35px;
              line-height: 10px;
              border-radius: 6px;
            }
          }
        }
        .btn_box1 {
          width: 160px;
          margin: -30px auto;
          position: relative;
          justify-content: center;
          display: flex;
          cursor: pointer;

          img {
            width: 160px;
            cursor: pointer;
          }
          img:hover {
            filter: alpha(Opacity=80);
            -moz-opacity: 0.8;
            opacity: 0.8;
          }
          span {
            position: absolute;
            top: 4px;
            left: 46px;
            display: flex;
            font-size: 18px;
            font-family: Alibaba PuHuiTi;
            font-weight: 500;
            color: #ffffff;
            z-index: 1999;
            cursor: pointer;

            //z-index: 9999;
          }
        }
      }
    }
  }
  //
  .authresults {
    width: 100%;
    // padding-top: 90px;
    height: 560px;
    background-color: #fff;
    text-align: center;
    position: relative;

    .title {
      width: 626px;
      height: 35px;
      margin-top: 41px;
      margin-bottom: 23px;
    }

    .result_bg {
      width: 100%;
      height: 128px;
      position: absolute;
      bottom: 0;
      left: 0;
    }
    .imageQrCode{
      display: flex;
      // justify-content: space-around;
      width: 1280px;
      margin: 80px auto 0 ;
      .itemImage{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .result_bg2{
          width: 140px;
          height: 140px;
        }
        .textname{
          font-weight: 550;
          font-size: 18px;
          color: #2A2A2A;
          margin-top: 10px;
        }
      }
      .bord{
        border-right: 1px solid #71ace2;
      }
    }
    .result_data {
      
      width: 1280px;
      height: 120px;
      bottom: 0;
      margin: 0 auto 0 auto;
      padding-top: 95px;
      display: flex;

      .item1 {
        width: 20%;
        height: 100%;
        border-right: 1px solid #71ace2;

        .icon {
          width: 62px;
          height: 62px;
        }

        p {
          height: 16px;
          font-size: 20px;
          font-family: Alibaba PuHuiTi;
          font-weight: 600;
          color: #2a2a2a;
          line-height: 16px;
          cursor: pointer;
        }

        .datas {
          height: 27px;
          font-size: 32px;
          font-family: Alibaba PuHuiTi;
          font-weight: bold;
          color: #2a2a2a;
          line-height: 27px;
          margin: 10px 0 0 0;
        }
      }

      .item2 {
        width: 30%;
        height: 100%;
        border-right: 1px solid #71ace2;
        text-align: center;

        .icon {
          width: 62px;
          height: 62px;
        }

        p {
          width: 100%;
          height: 16px;
          font-size: 20px;
          font-family: Alibaba PuHuiTi;
          font-weight: 600;
          color: #2a2a2a;
          line-height: 16px;
          // text-align: left;
          // margin-left: 40px;
          cursor: pointer;

          span {
            height: 28px;
            font-size: 32px;
            font-family: Alibaba PuHuiTi;
            font-weight: bold;
            color: #2a2a2a;
            line-height: 28px;
            margin: 0 5px;
          }
        }
      }

      .item3 {
        width: 20%;
        height: 100%;
        .datas {
          height: 27px;
          font-size: 32px;
          font-family: Alibaba PuHuiTi;
          font-weight: bold;
          color: #2a2a2a;
          line-height: 27px;
          margin: 10px 0 0 0;
        }
        .icon {
          width: 62px;
          height: 62px;
        }

        p {
          height: 16px;
          font-size: 20px;
          font-family: Alibaba PuHuiTi;
          font-weight: 600;
          color: #2a2a2a;
          line-height: 16px;
          cursor: pointer;

          span {
            height: 28px;
            font-size: 32px;
            font-family: Alibaba PuHuiTi;
            font-weight: bold;
            color: #2a2a2a;
            line-height: 28px;
            margin: 0 5px;
          }
        }

        .datas {
          height: 27px;
          font-size: 32px;
          font-family: Alibaba PuHuiTi;
          font-weight: bold;
          color: #2a2a2a;
          line-height: 27px;
          margin: 10px 0 0 0;
        }
      }
    }
  }
  .nationresults {
    width: 100%;
    // height: 450px;
    background-color: #fff;
    text-align: center;
    position: relative;

    .title {
      width: 626px;
      height: 35px;
      margin-top: 41px;
      margin-bottom: 23px;
    }

    // .result_bg {
    //   width: 100%;
    //   height: 128px;
    //   position: absolute;
    //   bottom: 0;
    //   left: 0;
    // }

    .result_data {
      width: 100%;
      height: 260px;
      display: flex;
      justify-content: space-evenly;

      .item1 {
        width: 24%;
        box-sizing: border-box;
        position: relative;
        .morelink {
          position: absolute;
          top: 10px;
          right: 10px;
          cursor: pointer;
          font-size: 14px;
          .iconstyle {
            background: #cccc;
            border-radius: 50%;
            color: #fff;
          }
        }
        /deep/ .el-tabs--border-card > .el-tabs__content {
          // padding-bottom: 36px;
          // background: #ccc;
        }
        /deep/ .el-tabs__item {
          font-size: 14px;
          color: #2d65a5;
        }
        ul {
          background: #eceff2;
          border-radius: 0 8px 8px 8px;
          li {
            font-size: 15px;
            width: 100%;
            height: 50px;
            text-align: left;
            line-height: 50px;
            padding-left: 28px;
            position: relative;
            a {
              color: #000;
            }
          }
          li::before {
            content: "";
            position: absolute;
            z-index: 2;
            left: 2%;
            top: 55%;
            margin-top: -3px;
            background: #666;
            height: 6px;
            width: 6px;
            border-radius: 50%;
            transform: translateY(-50%);
          }
        }
      }

      .item2 {
        width: 23%;
        box-sizing: border-box;
        position: relative;

        .morelink {
          position: absolute;
          top: 10px;
          right: 10px;
          cursor: pointer;
          font-size: 14px;
          .iconstyle {
            background: #cccc;
            border-radius: 50%;
            color: #fff;
          }
        }
        /deep/ .el-tabs--border-card > .el-tabs__content {
          // padding-bottom: 36px;
          // background: #ccc;
        }
        /deep/ .el-tabs__item {
          font-size: 14px;
          color: #2d65a5;
        }
        ul {
          background: #eceff2;
          border-radius: 0 8px 8px 8px;
          li {
            font-size: 15px;
            width: 100%;
            height: 50px;
            text-align: left;
            line-height: 50px;
            padding-left: 28px;
            position: relative;
            a {
              color: #000;
            }
          }
          li::before {
            content: "";
            position: absolute;
            z-index: 2;
            left: 2%;
            top: 55%;
            margin-top: -3px;
            background: #666;
            height: 6px;
            width: 6px;
            border-radius: 50%;
            transform: translateY(-50%);
          }
        }
      }
      .item3 {
        width: 25%;
        box-sizing: border-box;
        position: relative;
        .morelink {
          position: absolute;
          top: 10px;
          right: 10px;
          cursor: pointer;
          font-size: 14px;
          .iconstyle {
            background: #cccc;
            border-radius: 50%;
            color: #fff;
          }
        }
        /deep/ .el-tabs--border-card > .el-tabs__content {
          // padding-bottom: 36px;
          // background: #ccc;
        }
        /deep/ .el-tabs__item {
          font-size: 14px;
          color: #2d65a5;
        }
        ul {
          background: #eceff2;
          border-radius: 0 8px 8px 8px;
          li {
            font-size: 15px;
            width: 100%;
            height: 50px;
            text-align: left;
            line-height: 50px;
            padding-left: 28px;
            position: relative;
            a {
              color: #000;
            }
          }
          li::before {
            content: "";
            position: absolute;
            z-index: 2;
            left: 2%;
            top: 55%;
            margin-top: -3px;
            background: #666;
            height: 6px;
            width: 6px;
            border-radius: 50%;
            transform: translateY(-50%);
          }
        }
      }
      .item4 {
        width: 23%;
        box-sizing: border-box;
        position: relative;
        .morelink {
          position: absolute;
          top: 10px;
          right: 10px;
          cursor: pointer;
          font-size: 14px;
          .iconstyle {
            background: #cccc;
            border-radius: 50%;
            color: #fff;
          }
        }
        /deep/ .el-tabs--border-card > .el-tabs__content {
          // padding-bottom: 36px;
          // background: #ccc;
        }
        /deep/ .el-tabs__item {
          font-size: 14px;
          color: #2d65a5;
        }
        ul {
          background: #eceff2;
          border-radius: 0 8px 8px 8px;
          li {
            font-size: 15px;
            width: 100%;
            height: 50px;
            text-align: left;
            line-height: 50px;
            padding-left: 28px;
            position: relative;
            a {
              color: #000;
            }
          }
          li::before {
            content: "";
            position: absolute;
            z-index: 2;
            left: 2%;
            top: 55%;
            margin-top: -3px;
            background: #666;
            height: 6px;
            width: 6px;
            border-radius: 50%;
            transform: translateY(-50%);
          }
        }
      }
    }
  }

  //
  .results {
    width: 100%;
    height: 269px;
    background-color: #fff;
    text-align: center;
    position: relative;

    .title {
      width: 626px;
      height: 35px;
      margin-top: 41px;
      margin-bottom: 23px;
    }

    .result_bg {
      width: 100%;
      height: 128px;
      position: absolute;
      bottom: 0;
      left: 0;
    }

    .result_data {
      position: absolute;
      width: 1280px;
      height: 120px;
      left: 0;
      right: 0;
      top: 95px;
      bottom: 0;
      margin: 0 auto 0 auto;
      display: flex;

      .item1 {
        width: 20%;
        height: 100%;
        border-right: 1px solid #71ace2;

        .icon {
          width: 62px;
          height: 62px;
        }

        p {
          height: 16px;
          font-size: 16px;
          font-family: Alibaba PuHuiTi;
          font-weight: 400;
          color: #2a2a2a;
          line-height: 16px;
        }

        .datas {
          height: 27px;
          font-size: 32px;
          font-family: Alibaba PuHuiTi;
          font-weight: bold;
          color: #2a2a2a;
          line-height: 27px;
          margin: 10px 0 0 0;
        }
      }

      .item2 {
        width: 30%;
        height: 100%;
        border-right: 1px solid #71ace2;
        text-align: center;
        .datas {
          height: 27px;
          font-size: 32px;
          font-family: Alibaba PuHuiTi;
          font-weight: bold;
          color: #2a2a2a;
          line-height: 27px;
          margin: 10px 0 0 0;
        }
        .icon {
          width: 62px;
          height: 62px;
        }

        p {
          width: 100%;
          height: 16px;
          font-size: 16px;
          font-family: Alibaba PuHuiTi;
          font-weight: 400;
          color: #2a2a2a;
          line-height: 16px;
          // text-align: left;
          // margin-left: 40px;

          span {
            height: 28px;
            font-size: 32px;
            font-family: Alibaba PuHuiTi;
            font-weight: bold;
            color: #2a2a2a;
            line-height: 28px;
            margin: 0 5px;
          }
        }
      }

      .item3 {
        width: 20%;
        height: 100%;

        .icon {
          width: 62px;
          height: 62px;
        }

        p {
          height: 16px;
          font-size: 16px;
          font-family: Alibaba PuHuiTi;
          font-weight: 400;
          color: #2a2a2a;
          line-height: 16px;

          span {
            height: 28px;
            font-size: 32px;
            font-family: Alibaba PuHuiTi;
            font-weight: bold;
            color: #2a2a2a;
            line-height: 28px;
            margin: 0 5px;
          }
        }

        .datas {
          height: 27px;
          font-size: 32px;
          font-family: Alibaba PuHuiTi;
          font-weight: bold;
          color: #2a2a2a;
          line-height: 27px;
          margin: 10px 0 0 0;
        }
      }
    }
  }

  .area {
    width: 100%;
    height: 330px;
    background-color: #fff;
    position: relative;

    .bg {
      width: 100%;
      height: 100%;
    }

    .area_box {
      width: 1280px;
      height: 120px;
      position: absolute;
      left: 0;
      right: 0;
      top: 20px;
      bottom: 0;
      margin: 0 auto;
      display: grid;
      grid-template-columns: repeat(5, 20%);
      justify-content: center;

      .item {
        width: 234px;
        height: 120px;
        margin-top: 20px;
        position: relative;

        .item_bg {
          width: 234px;
          height: 120px;
        }

        .city {
          width: 200px;
          height: 25px;
          font-size: 26px;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
          color: #ffffff;
          line-height: 25px;
          text-shadow: 1px 2px 4px rgba(23, 27, 31, 0.26);
          margin: 25px 0 17px 25px;
          position: absolute;
          top: 0;
        }

        .datas {
          display: flex;
          position: absolute;
          top: 67px;

          .bus {
            margin-left: 27px;

            p {
              height: 13px;
              font-size: 14px;
              font-family: Alibaba PuHuiTi;
              font-weight: 400;
              color: #2a2a2a;
              line-height: 13px;
              margin: 0;
            }

            .num {
              height: 14px;
              font-size: 18px;
              font-family: Alibaba PuHuiTi;
              font-weight: bold;
              color: #2a2a2a;
              line-height: 14px;
              margin-top: 10px;
            }
          }
        }
      }
    }
  }

  .brand {
    height: 500px;
    background-color: #f6f7fb;
    text-align: center;
    position: relative;
    overflow: hidden;
    .xydtspp{
      width: 100%;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
      .xydtspp1{
        width: 410px;
        height: 120px;
        background-image: url("../assets/home/sb1.png");
        background-size: 410px 120px;
        background-repeat: no-repeat;
        display: flex;
        align-items: center;
        .titleImage{
          width: 82px;
          height: 20px;
          padding-left: 45px;
        }
      }
      .xydtspp2{
        width: 410px;
        height: 120px;
        background-image: url("../assets/home/pb1.png");
        background-size: 410px 120px;
        background-repeat: no-repeat;
        display: flex;
        align-items: center;
        .titleImage{
          width: 82px;
          height: 20px;
          padding-left: 45px;
        }
      }
      .xydtspp3{
        width: 410px;
        height: 120px;
        background-image: url("../assets/home/kb1.png");
        background-size: 410px 120px;
        background-repeat: no-repeat;
        display: flex;
        align-items: center;
        .titleImage{
          width: 82px;
          height: 20px;
          padding-left: 45px;
        }
      }
    }
    .title {
      width: 626px;
      height: 35px;
      margin-top: 23px;
      margin-bottom: 37px;
    }

    //.brand_box {
    //  height: 467px;
    //  width: 100%;
    //  margin: 0 auto;
    //  display: grid;
    //  grid-template-columns: repeat(4, 25%);
    //  justify-content: center;
    //
    //  .item {
    //    width: 300px;
    //    height: 128px;
    //    margin-bottom: 24px;
    //    display: flex;
    //    flex-direction: column;
    //    cursor: pointer;
    //    box-sizing: border-box;
    //
    //    .brand_img {
    //      width: 300px;
    //      height: 110px;
    //      box-sizing: border-box;
    //    }
    //
    //    .brand_text {
    //      width: 300px;
    //      height: 118px;
    //      padding: 0 30px;
    //      text-align: left;
    //      background: #fff;
    //      box-sizing: border-box;
    //
    //      .title {
    //        height: 22px;
    //        font-size: 22px;
    //        font-family: Alibaba PuHuiTi;
    //        font-weight: 500;
    //        color: #2a2a2a;
    //        line-height: 15px;
    //        margin: 20px 0 10px 0;
    //      }
    //      .bigBox {
    //        display: flex;
    //        justify-content: space-between;
    //        span {
    //          font-size: 14px;
    //          font-family: Alibaba PuHuiTi;
    //          font-weight: 400;
    //          color: #595858;
    //        }
    //        p {
    //          margin-top: 5px;
    //          font-size: 18px;
    //          font-family: Alibaba PuHuiTi;
    //          font-weight: 500;
    //          color: #2a2a2a;
    //        }
    //      }
    //    }
    //
    //    .brand_text:hover {
    //      background: linear-gradient(189deg, #589dff, #81c3ff, #67b9ff);
    //    }
    //  }
    //}
  }
  .question {
    width: 100%;
    height: 454px;
    background-color: #fff;
    text-align: center;
    position: relative;

    .title {
      width: 626px;
      //height: 35px;
      margin-top: 34px;
      //position: relative;
      //top: -20px;
    }

    .question_box {
      width: 1280px;
      position: absolute;
      left: 0;
      right: 0;
      top: 65px;
      bottom: 0;
      margin: auto;
      display: flex;
      justify-content: center;

      .left {
        width: 50%;
        position: relative;
        margin-right: -10px;

        .left1 {
          width: 640px;
          //height: 78px;
          margin-bottom: 4px;
        }

        .left_item {
          position: relative;

          .img {
            width: 640px;
            //height: 78px;
          }

          .text {
            position: absolute;
            left: 0;
            top: 0;
            cursor: pointer;
            width: 100%;
            height: 100%;
            font-size: 20px;
            font-family: Alibaba PuHuiTi;
            font-weight: 500;
            color: #2a2a2a;
            text-align: left;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding: 0 150px;
            box-sizing: border-box;
          }
        }
      }

      .right {
        width: 50%;
        position: relative;
        margin-top: 43px;
        margin-left: -10px;

        .left1 {
          width: 640px;
          //height: 78px;
          position: absolute;
          left: 10px;
          margin-top: 4px;
        }

        .left_item {
          position: relative;

          .img {
            width: 640px;
            //height: 78px;
          }

          .text {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            cursor: pointer;
            //width: 400px;
            font-size: 20px;
            font-family: Alibaba PuHuiTi;
            font-weight: 500;
            color: #2a2a2a;
            text-align: left;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding: 0 150px;
            box-sizing: border-box;
          }

          .texts {
            position: absolute;
            left: 110px;
            top: 28px;
            cursor: pointer;
            width: 400px;
            font-size: 20px;
            font-family: Alibaba PuHuiTi;
            font-weight: 500;
            color: #2a2a2a;
            text-align: left;
          }
        }
      }
    }
  }

  .cooperation {
    width: 100%;
    height: 400px;
    background-color: #f7f8fb;
    text-align: center;
    position: relative;

    .title {
      // width: 600px;
      height: 35px;
      margin-top: 31px;
      margin-bottom: 24px;
    }

    .cooperation_box {
      width: 1280px;
      height: auto;
      position: absolute;
      left: 20px;
      right: 0;
      top: 90px;
      bottom: 0;
      margin: auto;
      display: grid;
      grid-template-columns: repeat(4, 20%);
      justify-content: center;

      img {
        width: 240px;
      }
    }
  }

  .links {
    width: 100%;
    height: 233px;
    background-color: #fff;
    text-align: center;
    position: relative;

    .title {
      width: 626px;
      height: 35px;
      margin-top: 25px;
      margin-bottom: 47px;
    }

    .links_box {
      width: 1280px;
      position: absolute;
      left: 0;
      right: 0;
      top: 97px;
      bottom: 0;
      margin: auto;
      display: flex;
      justify-content: space-between;

      ul {
        text-align: left;
        margin-right: 50px;
      }

      li {
        font-size: 16px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #2a2a2a;
        margin-top: 25px;

        a {
          text-decoration: none;
          color: #2a2a2a;
        }

        a:visited {
          color: #2a2a2a;
          text-decoration: none;
        }
      }
    }
  }
}

/deep/ .myDialog {
  background: #f1f1f1;
  user-select: none;
  border-radius: 10px;

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;

    .a1 {
      font-weight: 500;
      font-size: 26px;
      color: black;
      margin-bottom: 10px;
    }

    .a2 {
      font-size: 18px;
      color: black;
      margin-bottom: 20px;
    }

    .a3 {
      width: 100%;
      background: #d9ece1;
      padding: 25px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 20px;

      img {
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }

      div {
        font-size: 20px;
        font-weight: 500;

        a {
          color: #2981ee;
          display: inline-block;
          margin-left: 5px;
          cursor: pointer;
          border-bottom: 1px solid #2981ee;
        }
      }
    }

    .a4 {
      width: 100%;
      background: white;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 30px;
      box-sizing: border-box;
      margin-bottom: 20px;

      .b1 {
        display: flex;
        font-size: 20px;
        font-weight: 500;
        color: #2a2a2a;
        margin-bottom: 10px;

        a {
          color: #2981ee;
          display: inline-block;
          margin-left: 5px;
          cursor: pointer;
          border-bottom: 1px solid #2981ee;
        }
      }

      .b2 {
        display: flex;
        font-size: 18px;
        color: #a2a4ac;
        margin-bottom: 20px;
      }

      .b3 {
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: center;
        height: 30px;
        padding-top: 20px;
        border-top: 1px solid #dedee0;

        img {
          width: 20px;
          height: 20px;
          margin-right: 5px;
        }

        div {
          font-size: 16px;
          color: #a9acb7;
        }
      }
    }

    .a6 {
      width: 60px;
      height: 60px;
      margin-bottom: 15px;
    }

    .a7 {
      color: black;
      font-size: 20px;
      margin-bottom: 10px;
    }

    .a8 {
      width: 40px;
      height: 40px;
      margin-bottom: 10px;
    }

    .a9 {
      color: black;
      font-size: 24px;
      margin-bottom: 10px;
    }

    .a5 {
      color: #2a2a2a;
      font-size: 15px;
    }
  }
  .audit {
    display: flex;
    flex-direction: column;
    align-items: center;

    .a1 {
      font-weight: 500;
      font-size: 26px;
      color: black;
      margin-bottom: 10px;
    }
    .a4 {
      width: 100%;
      background: white;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 30px;
      box-sizing: border-box;
      margin-bottom: 20px;

      .b1 {
        display: flex;
        font-size: 20px;
        font-weight: 500;
        color: #2a2a2a;
        margin-bottom: 10px;

        a {
          color: #2981ee;
          display: inline-block;
          margin-left: 5px;
          cursor: pointer;
          border-bottom: 1px solid #2981ee;
        }
      }

      .b2 {
        display: flex;
        font-size: 18px;
        color: #a2a4ac;
        margin-bottom: 20px;
      }

      .b3 {
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: center;
        height: 30px;
        padding-top: 20px;
        border-top: 1px solid #dedee0;

        img {
          width: 20px;
          height: 20px;
          margin-right: 5px;
        }

        div {
          font-size: 16px;
          color: #a9acb7;
        }
      }
    }
  }
  .myMainButton {
    background: #ddecff;
  }
}
/deep/.libaoDialog {
  background: unset;
  box-shadow: unset;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    position: relative;
    div {
      background: white;
      padding: 20px;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      h1 {
        color: black;
        text-align: center;
      }
    }
    img {
      width: 100%;
    }
    span {
      position: absolute;
      left: 240px;
      top: 480px;
      font-size: 35px;
      color: #d50d0f;
      font-weight: 550;
      background: linear-gradient(-88deg, #fed14b, #fcd167, #ffe8b0, #fdefc8);
      padding: 20px 40px;
      border-radius: 40px;
      cursor: pointer;
    }
  }
}
</style>
<style lang="less" scoped></style>
